module.exports = __webpack_public_path__ + "static/img/female-bg-pt.5a1c814e.png";